import React from 'react';
import PropTypes from 'prop-types';

import UserBan from 'admin-moderator/containers/UserBan';
import SendToAuthorButton from 'admin-moderator/containers/SendToAuthorButton';
import SocialLinks from 'admin-moderator/components/SocialLinks';

import { ReactComponent as Telegram } from 'icons/Socials/Telegram.svg';

import Avatar from 'components/Avatar';

import UserName from './UserName';
import UserInfo from './UserInfo';
import AvatarLink from './AvatarLink';
import ColumnInfo from './ColumnInfo';
import TelegramButton from './TelegramButton';

export class MaterialUser extends React.PureComponent {
  render() {
    return (
      <UserInfo>
        <AvatarLink to={`/users/${this.props.userId}`} banned={this.props.isBanned}>
          <Avatar
            name={this.props.fullname || '-'}
            url={this.props.avatar}
            size="56px"
          />
        </AvatarLink>

        <ColumnInfo>
          <UserName to={`/users/${this.props.userId}`} banned={this.props.isBanned}>
            {this.props.fullname || '-'}
          </UserName>

          <SocialLinks socialLinks={this.props.socialLinks} />
        </ColumnInfo>

        <div style={{ display: 'flex', alignItems: 'center' }}>
          <TelegramButton
            as="a"
            href={`https://t.me/share/url?url=${window.location.href}&text=${this.props.telegramText}`}
            target="_blank"
            rel="nofollow noopener"
            style={{ textDecoration: 'none' }}
          >
            <Telegram style={{ transform: 'translateY(-2px)' }} /> Отправить в телеграм
          </TelegramButton>

          <SendToAuthorButton userId={this.props.userId} onSendToAuthor={this.props.onSendToAuthor} />

          <UserBan
            userId={this.props.userId}
            isBanned={this.props.isBanned}
            onBan={this.props.onBan}
            fullName={this.props.fullname}
          />
        </div>
      </UserInfo>
    );
  }
}

MaterialUser.propTypes = {
  userId: PropTypes.string,
  isBanned: PropTypes.bool,
  fullname: PropTypes.string,
  avatar: PropTypes.string,
  socialLinks: PropTypes.arrayOf(PropTypes.shape({
    provider: PropTypes.oneOf(['vkontakte', 'odnoklassniki', 'facebook', 'twitter', 'instagram', 'google']),
    socialLink: PropTypes.string,
  })),

  telegramText: PropTypes.string,

  onBan: PropTypes.func,
  onSendToAuthor: PropTypes.func,
};

MaterialUser.defaultProps = {
  userId: '',
  isBanned: false,
  fullname: '',
  avatar: '',
  socialLinks: [],

  telegramText: '',

  onBan: () => {},
  onSendToAuthor: () => {},
};

export default MaterialUser;
